/**
 * @deprecated types are incomplete
 *  Take a function that expects varargs and turn it into a function that
    expects an array
*/
// oxlint-disable-next-line typescript/no-explicit-any
export const gather = (fn: (...args: any[]) => any) => (args: unknown) =>
  // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-return
  fn.apply(this, args);

/**
 * @deprecated types are incomplete
 */
export const partial =
  (
    f: (...args: any[]) => any, // oxlint-disable-line typescript/no-explicit-any
    ...args: unknown[]
  ) =>
  (...otherArgs: unknown[]) =>
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line @typescript-eslint/no-unsafe-return
    f(...args, ...otherArgs);

export function identity<T>(x: T): T {
  return x;
}
